import { cva } from '@/styled-system/css';

export const gleamLabelRecipe = cva({
  base: {
    display: 'inline-flex',
    textStyle: 'body-sm-bold',
  },

  variants: {
    tone: {
      default: {},
      info: {},
      new: {},
    },

    floating: {
      true: {
        position: 'absolute',
        right: 'calc({sizes.Gleam.positioning.default} * -1)',
        top: 'calc({sizes.Gleam.positioning.default} * -1)',
      },
      false: {},
    },

    floatingComponent: {
      Avatar: {},
      Icon: {},
    },

    floatingOffset: {
      xs: {},
      sm: {},
      md: {},
      lg: {},
      xl: {},
      xxl: {},
    },

    onImpact: {
      true: {},
      false: {},
    },
    appearance: {
      ellipsis: {
        backgroundColor: 'Gleam.bg',
        borderRadius: 'Gleam.default',
        color: 'Gleam.text',
        lineHeight: '{sizes.Gleam.height.min}',
        minWidth: 'Gleam.width.min',
        paddingLeft: 'Gleam.padding.horz',
        paddingRight: 'Gleam.padding.horz',
      },
      dot: {
        alignItems: 'center',
        height: 'Gleam.height.min',
        justifyContent: 'center',
        width: 'Gleam.width.min',
      },
    },
  },

  compoundVariants: [
    {
      tone: 'info',
      onImpact: false,
      appearance: 'ellipsis',
      css: {
        backgroundColor: 'Gleam.info.bg',
        color: 'Gleam.info.text',
      },
    },
    {
      tone: 'info',
      onImpact: true,
      appearance: 'ellipsis',
      css: {
        backgroundColor: 'Gleam.onImpact.info.bg',
        color: 'Gleam.onImpact.info.text',
      },
    },
    {
      tone: 'new',
      onImpact: false,
      appearance: 'ellipsis',
      css: {
        backgroundColor: 'Gleam.new.bg',
        color: 'Gleam.new.text',
      },
    },
    {
      tone: 'new',
      onImpact: true,
      appearance: 'ellipsis',
      css: {
        backgroundColor: 'Gleam.onImpact.new.bg',
        color: 'Gleam.onImpact.new.text',
      },
    },
    {
      floating: true,
      floatingComponent: 'Avatar',
      floatingOffset: 'md',
      css: {
        right: 'calc({sizes.Gleam.positioning.avatar.md} * -1)',
        top: 'calc({sizes.Gleam.positioning.avatar.md} * -1)',
      },
    },
    {
      floating: true,
      floatingComponent: 'Avatar',
      floatingOffset: 'lg',
      css: {
        right: 'calc({sizes.Gleam.positioning.avatar.lg} * -1)',
        top: 'calc({sizes.Gleam.positioning.avatar.lg} * -1)',
      },
    },
    {
      floating: true,
      floatingComponent: 'Avatar',
      floatingOffset: 'xl',
      css: {
        right: '{sizes.Gleam.positioning.avatar.xl}',
        top: '{sizes.Gleam.positioning.avatar.xl}',
      },
    },
    {
      floating: true,
      floatingComponent: 'Avatar',
      floatingOffset: 'xxl',
      css: {
        right: '{sizes.Gleam.positioning.avatar.xxl}',
        top: '{sizes.Gleam.positioning.avatar.xxl}',
      },
    },
    {
      floating: true,
      floatingComponent: 'Icon',
      floatingOffset: 'sm',
      css: {
        right: 'calc({sizes.Gleam.positioning.icon.sm} * -1)',
        top: 'calc({sizes.Gleam.positioning.icon.sm} * -1)',
      },
    },
    {
      floating: true,
      floatingComponent: 'Icon',
      floatingOffset: 'xl',
      css: {
        right: 'calc({sizes.Gleam.positioning.icon.xl} * -1)',
        top: 'calc({sizes.Gleam.positioning.icon.xl} * -1)',
      },
    },
  ],
});
